// Parses "resets at HH:MM(am/pm)? <tz>?" style text to a wake-at timestamp.
// Unparseable -> backoff ladder 15 -> 30 -> 60 (minutes), per
// research/brainstorm-report.md.
export interface RateLimitDetection {
  wakeAt: Date | null;
  backoffMinutes?: number;
}

const RESET_TIME_PATTERN =
  /resets?\s+(?:at\s+)?(\d{1,2})(?::(\d{2}))?\s*(am|pm)?\s*([A-Za-z]{2,5})?/i;

const BACKOFF_LADDER_MINUTES = [15, 30, 60];

// attemptNumber is 1-indexed (first unparseable hit = 15min, second = 30min,
// third+ = 60min, matching the ladder's final rung).
export function detectRateLimitWakeAt(text: string, attemptNumber = 1): RateLimitDetection {
  const match = text.match(RESET_TIME_PATTERN);
  if (match) {
    const hourRaw = Number(match[1]);
    const minute = match[2] ? Number(match[2]) : 0;
    const meridiem = match[3]?.toLowerCase();

    let hour = hourRaw;
    if (meridiem === "pm" && hour < 12) hour += 12;
    if (meridiem === "am" && hour === 12) hour = 0;

    if (hour >= 0 && hour <= 23 && minute >= 0 && minute <= 59) {
      const now = new Date();
      const wakeAt = new Date(now);
      wakeAt.setHours(hour, minute, 0, 0);
      if (wakeAt.getTime() <= now.getTime()) {
        wakeAt.setDate(wakeAt.getDate() + 1); // reset time already passed today -> tomorrow
      }
      return { wakeAt };
    }
  }

  const ladderIndex = Math.min(attemptNumber - 1, BACKOFF_LADDER_MINUTES.length - 1);
  return { wakeAt: null, backoffMinutes: BACKOFF_LADDER_MINUTES[ladderIndex] };
}
